import React from 'react';
import ChevronDown from '../assets/images/ChevronDownIcon.svg';

export default () => {
  return <img src={ChevronDown} alt="" />;
};
